import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  Inject,
  NgZone,
  OnInit,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import {
  MATOMO_CONFIGURATION,
  MatomoConfiguration,
  MatomoTracker,
} from "@ngx-matomo/tracker";
import {
  PoModalAction,
  PoModalComponent,
  PoNotificationService,
} from "@po-ui/ng-components";
import { MainService } from "../app.service";
import { Areas } from "../classes/Areas";
import { MenuRoute } from "../classes/Menu";
import { Token } from "../classes/Token";
import { Roles } from "../enums/roles";
import { RoleTag, resolveRoleTag } from "../shared/role-tags";

@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.css"],
})
export class MenuComponent implements OnInit {
  @ViewChild("cadastraArea", { static: false })
  selectAreaModal: PoModalComponent;
  @ViewChild("getPATAToken", { static: false }) getPATAToken: PoModalComponent;
  @ViewChild("getCompileKey", { static: false })
  getCompileKey: PoModalComponent;

  actualArea: string = this.mainservice.userToken.area;
  areas: any[] = [];
  areasLoading: boolean = false;
  areasLoadFailed: boolean = false;
  areaSelected: string = "";
  selectedTribe: string = "";
  saveArea: PoModalAction = {
    action: () => this.saveUserArea(),
    label: "Salvar",
    disabled: true,
  };

  closeCompileKeyAction: PoModalAction = {
    action: () => {
      this.closeCompileKeyModal();
    },
    label: "Fechar",
  };

  // PATA TOKEN
  tokenExists: boolean = false;
  tokenColumns: Array<any> = [];
  tokens: Array<any> = [];
  tokenUser: string = "";
  tokenData: string = "";
  tokenDate: string = "";
  tUsername: string = "";
  tPassword: string = "";
  patatoken: string = "";
  compileKey = {
    payload: {
      iss: "",
      sub: "",
      auth: "",
      exp: "",
    },
    token: "",
  };
  pataTokenDownloadDisabled: boolean = false;
  openedFromProfile: boolean = false;

  userEmail: string = "";
  userProfileImage: string = "";
  showAvatarMenu: boolean = false;
  toolbarProfile: any = {};
  showProfilePopover: boolean = false;

  menu: Array<any> = [];
  roles: typeof Roles = Roles;

  get isDeveloper(): boolean {
    return !!this.mainservice.isDeveloper;
  }

  get userRoleTags(): Array<RoleTag> {
    const roles = (this.mainservice.sRoles || [])
      .filter((role) => typeof role === "string")
      .map((role) => role.trim())
      .filter((role) => role !== "");

    const uniqueRoles = Array.from(new Set<string>(roles));

    return uniqueRoles.map((role) => resolveRoleTag(role));
  }


  constructor(
    private router: Router,
    public mainservice: MainService,
    public poNotification: PoNotificationService,
    public cd: ChangeDetectorRef,
    private readonly renderer: Renderer2,
    private readonly destroyRef: DestroyRef,
    private readonly ngZone: NgZone,
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly tracker: MatomoTracker,
    @Inject(MATOMO_CONFIGURATION) private readonly config: MatomoConfiguration,
  ) {
    (config.siteId === "1", config.trackerUrl === "//10.171.80.34:9603/");
  }

  ngOnInit(): void {
    this.tracker.trackPageView("Menu");
    this.getAreas();
    this.getMenu();
    this.loadMcpUserAccess();
    this.registerAriaHiddenFocusGuard();
    this.loadUserProfileImage();
    this.refreshUserAreaSession();
    let rolesKey = JSON.stringify(this.mainservice.sRoles);
    const areaSub = this.mainservice.sessionAreaChanged.subscribe(() => {
      this.actualArea = this.mainservice.userToken.area;
      this.loadMcpUserAccess();
      const currentRolesKey = JSON.stringify(this.mainservice.sRoles);
      if (currentRolesKey !== rolesKey) {
        rolesKey = currentRolesKey;
        this.getMenu();
      }
      this.cd.markForCheck();
    });
    this.destroyRef.onDestroy(() => areaSub.unsubscribe());
    this.destroyRef.onDestroy(() => {
      if (this.userProfileImage && this.userProfileImage.startsWith("blob:")) {
        URL.revokeObjectURL(this.userProfileImage);
      }
    });
  }

  ngAfterViewInit() {
    if (!this.mainservice.userToken.area || this.mainservice.userToken.area === "undefined") {
      this.openSelectArea();
    } else {
      this.router.navigate(["menu/home"]);
    }
    this.router.navigate(["menu/home"]);
    this.cd.detectChanges();
  }

  private registerAriaHiddenFocusGuard(): void {
    this.ngZone.runOutsideAngular(() => {
      const unlisten = this.renderer.listen(
        this.document,
        "focusin",
        (event: FocusEvent) => {
          const target = event.target;
          if (
            target instanceof HTMLElement &&
            target.closest('[aria-hidden="true"]')
          ) {
            target.blur();
          }
        },
      );
      this.destroyRef.onDestroy(unlisten);
    });
  }

  openSelectArea() {
    this.selectAreaModal.open();
  }

  private menuSub?: Subscription;

  getMenu() {
    // Duas chamadas em voo (ngOnInit e a mudanca de roles) anexariam o menu duas vezes: so a ultima vale
    this.menuSub?.unsubscribe();
    this.menu = [];

    this.menuSub = this.mainservice.getMenu().subscribe((res) => {
      const pending: { menuTemp: MenuRoute; subItem: string }[] = [];

      res.forEach((element) => {
        const menuTemp = new MenuRoute();
        menuTemp.id = element.id;
        menuTemp.userType = element.userType;
        menuTemp.label = element.label;
        menuTemp.shortLabel = element.label;
        menuTemp.action = () => new Function(element.action).call(this);
        menuTemp.link = element.link;
        menuTemp.locale = element.locale;
        menuTemp.icon = element.icon;
        menuTemp.position = element.position;
        menuTemp.published = element.published;

        if (this.mainservice.userToken.role === "superuser") {
          pending.push({ menuTemp, subItem: element.subItem });
          return;
        }

        if (element.published === false) {
          return;
        }

        if (this.matchesUserType(menuTemp.userType)) {
          pending.push({ menuTemp, subItem: element.subItem });
        }
      });

      // A API não garante que um item pai (ex. "MCP") venha antes dos seus
      // filhos (ex. "Users"/"Reports") no array retornado. Como
      // insertMenuInArray só resolve o pai se ele já existir na árvore,
      // repetimos passes até estabilizar (sem mais progresso) para
      // suportar qualquer ordem e qualquer profundidade de níveis.
      let remaining = pending;
      let progressed = true;
      while (remaining.length > 0 && progressed) {
        progressed = false;
        remaining = remaining.filter((item) => {
          const inserted = this.insertMenuInArray(item.menuTemp, item.subItem);
          if (inserted) {
            progressed = true;
          }
          return !inserted;
        });
      }

      this.sortMenuByPosition();
    });
  }

  /**
   * Casa o `userType` do item de menu com as roles do usuário. Um `userType` sem
   * ponto vale como coringa do produto: `smartreview` casa qualquer capability
   * `smartreview.*`. Já `smartreview.admin` exige match exato.
   */
  matchesUserType(userType: string[]): boolean {
    const roles: string[] = this.mainservice.sRoles || [];

    return (userType || []).some((type) => {
      if (roles.includes(type)) {
        return true;
      }

      return (
        !type.includes(".") &&
        roles.some(
          (role) => typeof role === "string" && role.startsWith(`${type}.`),
        )
      );
    });
  }

  /**
   * Insere `menuTemp` sob o item cujo `label` seja `subItem`, buscando o pai
   * recursivamente em qualquer profundidade da árvore (não só no primeiro
   * nível), já que o menu suporta até 4 níveis. Retorna `true` se o pai foi
   * encontrado e a inserção ocorreu, `false` caso o pai ainda não exista na
   * árvore (permitindo ao chamador reprocessar depois, quando a ordem de
   * chegada dos itens da API não respeita a hierarquia).
   */
  insertMenuInArray(menuTemp, subItem): boolean {
    if (subItem !== "") {
      const parent = this.findMenuItemByLabel(this.menu, subItem);
      if (!parent) {
        return false;
      }
      menuTemp.subItems = menuTemp.subItems || [];
      parent.subItems.push(menuTemp);
      return true;
    } else {
      menuTemp.subItems = menuTemp.subItems || [];
      this.menu = [...this.menu, menuTemp];
      return true;
    }
  }

  private findMenuItemByLabel(items: any[], label: string): any {
    for (const item of items) {
      if (item.label === label) {
        return item;
      }
      if (item.subItems && item.subItems.length > 0) {
        const found = this.findMenuItemByLabel(item.subItems, label);
        if (found) {
          return found;
        }
      }
    }
    return null;
  }

  sortMenuByPosition() {
    this.menu.sort((a, b) => {
      const positionA = parseInt(a.position, 10);
      const positionB = parseInt(b.position, 10);
      return positionA - positionB;
    });

    this.menu.forEach((item) => this.sortSubItemsByPositionRecursive(item));
  }

  private sortSubItemsByPositionRecursive(item: any): void {
    if (item.subItems && item.subItems.length > 0) {
      item.subItems.sort((a, b) => {
        const subPositionA = parseInt(a.position, 10);
        const subPositionB = parseInt(b.position, 10);
        return subPositionA - subPositionB;
      });
      item.subItems.forEach((subItem) =>
        this.sortSubItemsByPositionRecursive(subItem),
      );
    }
  }

  get areaPlaceholder(): string {
    if (this.areasLoading) return "Carregando áreas...";
    if (this.areasLoadFailed) return "Não foi possível carregar as áreas";
    return "Digite para buscar ou selecione a área";
  }

  getAreas() {
    this.mainservice.workAreas = [];
    this.areas = [];
    this.areasLoading = true;
    this.areasLoadFailed = false;

    this.mainservice.getAreas().subscribe({
      next: (res) => {
        const retorno: any = res;
        const options: any[] = [];
        retorno.forEach((element) => {
          const areasTemp = new Areas();

          areasTemp.id = element.id;
          areasTemp.area = element.area;
          areasTemp.restricted = element.restricted;
          this.mainservice.workAreas.push(areasTemp);
          options.push({ value: areasTemp.area, label: areasTemp.area, tribe: element.tribeName || "" });
        });
        this.areas = options.sort((a, b) => a.label.localeCompare(b.label, "pt-BR"));
        this.areasLoading = false;
        this.cd.markForCheck();
      },
      error: () => {
        this.areasLoading = false;
        this.areasLoadFailed = true;
        this.cd.markForCheck();
      },
    });
  }

  // A tribe e so informativa: vem da area escolhida
  onAreaSelected(area: string): void {
    this.areaSelected = area || "";
    this.selectedTribe = this.areas.find((a) => a.value === area)?.tribe || "";
    this.saveArea.disabled = !area;
  }

  saveUserArea() {
    if (!this.areaSelected || this.saveArea.loading) return;
    this.saveArea.loading = true;
    this.saveArea.disabled = true;
    this.mainservice
      .changeArea(this.mainservice.userToken.username, this.areaSelected)
      .subscribe({
        next: () => {
          this.saveArea.loading = false;
          this.selectAreaModal.close();
          this.poNotification.success(`Área de trabalho definida: ${this.areaSelected}`);
          this.refreshUserAreaSession(); // tribe e roles da area escolhida
        },
        error: () => {
          // o modal nao fecha: o usuario ainda precisa de uma area
          this.saveArea.loading = false;
          this.saveArea.disabled = !this.areaSelected;
          this.poNotification.error("Não foi possível salvar a área. Tente novamente.");
        },
      });
  }

  openPATAToken() {
    this.tokens = [];
    this.tokenExists = false;
    this.tokenUser = "";
    this.tokenData = "";
    this.tokenDate = "";

    this.mainservice.getPATAToken().subscribe((res) => {
      const retorno: any = res;
      retorno.forEach((element) => {
        const tokenTemp = new Token();
        tokenTemp.id = element._id;
        tokenTemp.username = element.username;
        tokenTemp.token = element.token;
        tokenTemp.createdAt = element.createdAt;
        this.tokens.push(tokenTemp);
        this.tokenExists = true;
        this.tokenUser = element.username;
        this.tokenData = element.token;
        this.tokenDate = element.createdAt;
      });
    });
    this.getPATAToken.open();
  }

  closeCompileKeyModal(): void {
    this.getCompileKey.close();
    if (this.openedFromProfile) {
      this.openedFromProfile = false;
      this.showProfilePopover = true;
    }
  }

  openCompileKeyFromProfile(): void {
    this.openedFromProfile = true;
    this.showProfilePopover = false;
    this.openCompileKey();
  }

  openCompileKey() {
    this.compileKey = {
      payload: {
        iss: "",
        sub: "",
        auth: "",
        exp: "",
      },
      token: "",
    };
    this.pataTokenDownloadDisabled = false;

    this.mainservice.getCompileToken().subscribe({
      next: (data) => {
        this.compileKey = data;
      },
      error: (error) => {
        console.error("Erro ao gerar token:", error);
        this.getCompileKey.close();
        this.poNotification.error(
          "Falha ao gerar token de compilação! Tente novamente mais tarde.",
        );
      },
    });
    this.getCompileKey.open();
  }

  generatePATAToken() {
    if (this.tUsername !== "" && this.tPassword !== "") {
      this.mainservice
        .createPATAToken(this.tUsername, this.tPassword)
        .subscribe((res) => {
          this.tokenData = res;
        });
    }
  }

  deletePATAToken() {
    this.mainservice.deletePATAToken(this.tokens[0].id).subscribe((res) => {
      this.openPATAToken();
    });
  }

  downloadPATAToken(): void {
    const blob = new Blob([this.compileKey.token.replace(/\n/g, "")], {
      type: "text/plain",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${this.compileKey.payload.sub.replace(".", "_")}.token`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    this.pataTokenDownloadDisabled = true;
  }

  loadMcpUserAccess() {
    this.toolbarProfile = {
      title: this.mainservice.userToken.username,
      subtitle: this.mainservice.userToken.area,
    };
  }

  private refreshUserAreaSession(): void {
    this.mainservice
      .refreshSessionArea()
      .subscribe(); // quem atualiza o perfil e o handler de sessionAreaChanged (ngOnInit)
  }

  getFullName(): string {
    const username = this.mainservice.userToken.username || "";
    const parts = username.split(".");
    if (parts.length >= 2) {
      return parts
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(" ");
    }
    return username;
  }

  getUserInitials(): string {
    const username = this.mainservice.userToken.username || "";
    const parts = username.split(".");
    if (parts.length >= 2) {
      return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();
    }
    return username.substring(0, 2).toUpperCase();
  }

  openMcpUserAccess(): void {
    this.showProfilePopover = !this.showProfilePopover;
    if (this.showProfilePopover) {
      // mostra o que esta na sessao e atualiza area, tribe e roles (podem ter mudado pela gestao de usuarios)
      this.loadMcpUserAccess();
      this.refreshUserAreaSession();
      this.loadUserProfileImage();
    }
  }

  closeProfilePopover(): void {
    this.showProfilePopover = false;
    this.showAvatarMenu = false;
  }

  handleProfileClick(event: any): void {
    const profileElement = event.target?.closest(
      '[class*="po-toolbar-profile"]',
    );
    if (profileElement) {
      event.stopPropagation();
      this.openMcpUserAccess();
    }
  }

  loadUserProfileImage(force: boolean = false): void {
    if (this.userProfileImage && !force) {
      return;
    }

    this.mainservice.getProfilePicture().subscribe({
      next: (url: string) => this.setUserProfileImage(url),
      error: () => this.setUserProfileImage(""),
    });
  }

  private setUserProfileImage(url: string): void {
    // A foto agora vem como blob autenticado e é renderizada via object URL.
    // Revoga a URL anterior para não vazar memória ao trocar/atualizar a foto.
    if (this.userProfileImage && this.userProfileImage.startsWith("blob:")) {
      URL.revokeObjectURL(this.userProfileImage);
    }
    this.userProfileImage = url;
    this.cd.detectChanges();
  }

  triggerFileInput(): void {
    const fileInput = document.getElementById(
      "profileImageInput",
    ) as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  onProfileImageSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const files = input.files;

    if (files && files.length > 0) {
      const file = files[0];

      // Validar tipo de arquivo
      if (!file.type.startsWith("image/")) {
        this.poNotification.warning("Por favor, selecione uma imagem válida.");
        return;
      }

      // Validar tamanho (máximo 5MB)
      const maxSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxSize) {
        this.poNotification.warning("O arquivo não pode exceder 5MB.");
        return;
      }

      // Criar FormData para enviar arquivo
      const formData = new FormData();
      formData.append("file", file);

      this.mainservice.uploadProfilePicture(formData).subscribe({
        next: () => {
          this.loadUserProfileImage(true);
          this.poNotification.success("Foto de perfil atualizada com sucesso!");
        },
        error: (error) => {
          console.error("Erro ao fazer upload:", error);
          this.poNotification.error(
            "Erro ao fazer upload da foto. Tente novamente.",
          );
        },
      });
    }
  }

  removeProfileImage(): void {
    this.mainservice.deleteProfilePicture().subscribe({
      next: () => {
        this.setUserProfileImage("");
        this.poNotification.success("...");
      },
      error: (error) => {
        console.error("Erro ao remover foto:", error);
        this.poNotification.error("Erro ao remover foto. Tente novamente.");
      },
    });
  }
}
